import FlyingGame from './FlyingGame.vue';
import FlyingGameList from './FlyingGameList.vue';
export default {
  FlyingGame,
  FlyingGameList,
};
